import script from "./DefLangSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefLangSelect.vue?vue&type=script&lang=ts&setup=true"

import "./DefLangSelect.vue?vue&type=style&index=0&id=55bb2dc7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55bb2dc7"]])

export default __exports__